export const realtorData = {
  email: 'trijaval@unne.cl',
  phone: '997548637'
  // email: 'contacto@accionpanal.com',
};
